import { useEffect } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import Benefits from './components/Benefits';
import Comparison from './components/Comparison';
import CaseStudies from './components/CaseStudies';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

export default function HomePage() {
  useSEO({
    title: '智研云 - 智能研发费用管理系统 | 研发费用加计扣除 | 高新技术企业认定',
    description: '智研云是专业的研发费用管理系统,提供智能数据归集、精准费用核算、一键生成报表等功能,助力企业高效管理研发投入,享受税收优惠政策,轻松通过高新技术企业认定。',
    keywords: '研发费用管理,研发费用加计扣除,高新技术企业认定,研发项目管理,研发成本核算',
    canonical: '/',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '智研云',
      url: import.meta.env.VITE_SITE_URL || 'https://example.com',
      logo: 'https://static.readdy.ai/image/f3112bc369a9d36317555af5f615a961/c148769dbd44feb46d8460b2c5ef91cc.png',
      description: '智研云是专业的研发费用管理系统,提供智能数据归集、精准费用核算、一键生成报表等功能,助力企业高效管理研发投入,享受税收优惠政策,轻松通过高新技术企业认定。',
      sameAs: [],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: '客户服务',
        availableLanguage: 'zh-CN'
      }
    }
  });

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Benefits />
        <Comparison />
        <CaseStudies />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
